// tslint:disable-next-line: export-name
export const LOADER_ANIMATION_LENGTH = 2000;
export const FADEOUT_ANIMATION_DURATION = 1000;
